import { numberToPrettyString } from '@cian/utils';
import { IOffer } from '../../../../types/offer';

export function getSalePrice(offer: IOffer): string {
  let formattedPrice = numberToPrettyString(offer.bargainTerms.priceRur);

  return `${formattedPrice}\u00A0₽`;
}
